import Checkbox from 'components/form/Checkbox';
import { useHasActivatedBetaFeatures } from 'hooks/useHasActivatedBetaFeatures';
import { FormattedMessage } from 'react-intl';

import styles from './IsBetaUserToggle.module.scss';

const IsBetaUserToggle = (): JSX.Element => {
  const { hasActivatedBetaFeatures, setHasActivatedBetaFeatures } = useHasActivatedBetaFeatures();

  return (
    <div className={styles.isBetaUserContainer}>
      <FormattedMessage id="header.profile.activateBetaFeatures" />
      <Checkbox
        checked={hasActivatedBetaFeatures ?? false}
        onChange={event => setHasActivatedBetaFeatures(event.currentTarget.checked)}
      />
    </div>
  );
};

export default IsBetaUserToggle;
